import { auth } from '@/store/app/auth/auth';
import { DrawerModule } from '@/store/app/drawer/drawer';
import { ErrorsModule } from '@/store/app/errors/ErrorsModule';

export const app = {
  namespaced: true,
  modules: {
    auth,
    errors: ErrorsModule,
    drawer: DrawerModule
  }
};
